import { addNotFoundPrograms } from '../../../phoenix/data/program/addNotFoundPrograms';
import { processPhoenixPrograms } from '../../../phoenix/processing';
import { fetchEpg } from '../../services/epg';

type FetchChannelProgramsArgs = {
  channelId: number;
  startDate: number;
  endDate: number;
};

export async function fetchChannelPrograms({ startDate, endDate, channelId }: FetchChannelProgramsArgs) {
  // @ts-expect-error TODO Fix
  const { epgChunk } = await fetchEpg({
    channels: [channelId],
    responseProfileId: 1,
    slots: 'all',
    timestamp: startDate,
  });

  const programs = processPhoenixPrograms(epgChunk[channelId] ?? [], channelId);

  return addNotFoundPrograms({ programs, channelId, startDate, endDate });
}
